import InboundContainer from '@components/containers/warehouseOps/grn/InboundContainer';
import { getOrgConfig } from '@api/organization';
import { useCurrentUser } from '@hooks/useCurrentUser';
import { useQuery } from '@tanstack/react-query';
import AppLayout from '@layouts/AppLayout';
import { Navigate } from 'react-router';
import type { FC } from 'react';

const WarehouseInbound: FC = () => {
    const { currentUser } = useCurrentUser();
    const organizationId = currentUser?.organizationId;

    const { data: orgConfig, isLoading } = useQuery({
        queryKey: ['org-config', organizationId],
        queryFn: () => getOrgConfig(organizationId!),
        enabled: !!organizationId,
        staleTime: 5 * 60 * 1000,
    });

    if (isLoading) return null;
    if (!orgConfig?.warehouseOpsEnabled) return <Navigate to="/home" replace />;

    return (
        <AppLayout>
            <InboundContainer />
        </AppLayout>
    );
};

export default WarehouseInbound;
